import { render, staticRenderFns } from "./NonCCRDashboardSection.vue?vue&type=template&id=1025c810&scoped=true&"
import script from "./NonCCRDashboardSection.vue?vue&type=script&lang=js&"
export * from "./NonCCRDashboardSection.vue?vue&type=script&lang=js&"
import style0 from "./NonCCRDashboardSection.vue?vue&type=style&index=0&id=1025c810&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1025c810",
  null
  
)

export default component.exports